import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import { fileExtensionStylingMap, genericFile } from "~/components/FileExtensionPreview/types";
import { CLIP_PREVIEW_IMAGE } from "~/constants/testIDs";
import { centralizedClipExtSelector, centralizedClipFormattedSizeSelector, centralizedDisplayTitleSelector } from "~/store/centralizedClip/selectors";
export const FileVisualizer = /*#__PURE__*/ memo(()=>{
    const ext = useSelector(centralizedClipExtSelector);
    const title = useSelector(centralizedDisplayTitleSelector);
    const formattedSize = useSelector(centralizedClipFormattedSizeSelector);
    const extStyles = useMemo(()=>{
        const normalizedExt = (ext === null || ext === void 0 ? void 0 : ext.toLowerCase()) || ""; // to support e.g. JPG
        return normalizedExt in fileExtensionStylingMap ? fileExtensionStylingMap[normalizedExt] : genericFile;
    }, [
        ext
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": CLIP_PREVIEW_IMAGE,
        className: "flex min-h-[380px] flex-col items-center justify-center md:min-h-0",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex size-[64px] items-center justify-center rounded-8 md:size-[100px] md:rounded-12",
                style: {
                    backgroundColor: extStyles.bgColor,
                    color: extStyles.iconColor
                },
                children: /*#__PURE__*/ _jsx(extStyles.iconComponent, {
                    className: "block w-10 md:w-16"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-4 text-18 font-medium text-grey-12 md:mt-6 md:text-24",
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-1 text-14 text-grey-10 md:mt-2 md:text-16",
                children: "".concat(ext, " ∙ ").concat(formattedSize)
            })
        ]
    });
});
FileVisualizer.displayName = "FileVisualizer";
